  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  // console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  });

  document.querySelectorAll('.prod-variants li').forEach(function (element) {
  element.addEventListener('click', function (e) {
    var variantId = element.getAttribute('variant_id');
    window.holaa = element.getAttribute('data-value');
    e.preventDefault();
    e.stopPropagation();

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onload = function () {
      if (xhr.status === 200) {
        var data = JSON.parse(xhr.responseText);
        window.location.href = "/cart";
      }
    };

    var requestData = {
      quantity: 1,
      id: window.holaa
    };

    xhr.send(JSON.stringify(requestData));
  });
});

if (document.getElementById('myModal')) {
  var isShow = localStorage.getItem('isshow');
  
  if (isShow == null) {
    localStorage.setItem('isshow', 1);

    // Show popup here
    document.body.style.overflow = 'hidden';
    document.getElementById('myModal').style.display = 'block';
  }

  document.addEventListener('click', function (event) {
    var closeModalButton = document.querySelector('#myModal .modal-content .close');
    if (event.target === closeModalButton) {
      document.getElementById('myModal').style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  });
}

$(document).ready(function(){

  $('.product-pop-main .newsletter__wrapper .newsletter-form__field-wrapper input').keyup(function(){
    var txt = $(this).val();
    $('form.newsletter-form .newsletter-form__field-wrapper input').val(txt);
  })
  
  $(document).on('click','.product-pop-main .newsletter-form__button',function(e){
    e.preventDefault();
    $('form.newsletter-form .newsletter-form__button').trigger('click');
  })
  
})
